<div class="left-menu-container" tabindex="0" data-message="GARS Left Navigation" aria-label="Left Navigation" role="navigation">
  <div tabindex="0" class="mainLogo" (keyup.enter)="loginPageredirect()" (click)="loginPageredirect()"> <img [src]="logo" [class.cursor-pointer]="!pdfBackup" alt="Logo Image"></div>
  <div #navLevel1 class="mt-4">
    <div *ngIf="!isArchive" tabindex="0" class="search-margin navElement" [class.selectedNavElement]="isSearchClicked && highlight == undefined" (click)="selectedIndexLevel1 = 100;isSearchClicked = true;highlight = undefined; popupRedirect(1,2)" (keyup.enter)="selectedIndexLevel1 = 100;highlight = undefined;isSearchClicked = true;popupRedirect(1,2)">
      <img class="navLogo" [src]="searchIcon" alt="Search/Go To">
      <div class="navNameLevel1 m-Auto">
        {{searchLabel}}
      </div>
    </div>
    <div *ngFor="let obj of tempData, index as i" tabindex="0" class="navElement" [class.spaceOnBottom]="obj.spaceOnBottom" [class.spaceOnTop]="obj.spaceOnTop" [class.subNavDisabledElement]="(obj.itemData.length == 0 && obj.itemLink == null && obj.item =='My GARS' )" [class.ml36px]="(obj.itemData.length == 0 && obj.itemLink == null && obj.item =='My GARS' )" [class.selectedFirstNavElement]="((l2State == 'in') ? i === selectedIndexLevel1 : obj.item === area)" (click)="selectedIndexLevel1 = i;highlight=i; navClicked(obj,1)" (keyup.enter)="selectedIndexLevel1 = i;highlight=i; navClicked(obj,1)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowRight)="nextLevel(1)">
      <img *ngIf="obj.logoSrc != null && obj.item != 'Logout' && obj.itemData.length != 0" class="navLogo" [src]="obj.logoSrc" [alt]="obj.item">
      <img *ngIf="obj.logoSrc != null && obj.item != 'Logout' && obj.itemData.length == 0 && obj.itemLink == null && obj.item =='My GARS'" class="navLogo" src="../../../assets/icons/User-disabled.svg" [alt]="obj.item">
      <img *ngIf="obj.item == 'Logout'" class="navLogo" src="../../../assets/icons/logout-white.svg" alt="Logout Icon" [alt]="obj.item">
      <div class="m-Auto" [class.navNameLevel1]='!obj.item.includes("Update")' [class.font-14-leftNav]='obj.item.includes("Update")' [class.subNavDisabledElement]="(obj.itemData.length == 0 && obj.itemLink == null &&obj.item =='My GARS' )" [innerHTML]="obj.item">
      </div>
      <div *ngIf="obj.itemData.length > 0" class="m-Auto">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </div>
    </div>
  </div>
</div>
<div *ngIf="flag" #navLevel2 class="menu-overlay-level-2" [class.z-index-negative]="menuIndexNegativeArr[0]" [@slideInOut]="l2State" (@slideInOut.done)="animationDone(l2State,0)" (@slideInOut.start)="animationStart(l2State,0)">
  <div class="fullComponent">
    <div class="searchBox">
      <div class="pt-85px">
        <div class="searchtext white-color">{{searchtext}}</div>
        <div class="flex-display">
          <mat-form-field class="width-80 whitecolor" floatLabel="never">
            <input matInput type="text" [(ngModel)]="searchText" (input)="applyFilter($event.target.value)" (keyup.enter)="searchComponentRedirection()" class="searchinput" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of autoSuggestion" [value]="option.text" (click)="suggestedValue(option.text)" >
                {{option.text}}
              </mat-option>
            </mat-autocomplete>
            <mat-placeholder class="searchinput">{{enterText}}</mat-placeholder>
          </mat-form-field>
          &nbsp;
          <button mat-button>
            <div [ngClass]="searchText ? 'accept-search-result' : 'showallbutton'" (click)="searchComponentRedirection()" (keyup.enter)="searchComponentRedirection()">{{showButton}}</div>
          </button>
        </div>
      </div>
      <div class="pb-2rem">
      </div>
    </div>


    <div *ngIf="searchText != '' && searchText != null" class="searchSuggestion" [ngClass]="(category>0)?'pb-2rem':'pb-20per'">

      <div>
        <div class="showing-top-results pb-2rem">{{topResults}} {{searchText}}</div>
        <div class="flex-display width-100 pb-3">
          <div *ngFor="let SearchTab of searchTabHeading" [ngClass]="role=='Basic'?'width-33':'width-25'">
            <div *ngIf="SearchTab == codification" class="pt-1-25 pr-3 pr-1rem">
              <div class="searchtable height-80px">{{codification}}</div>
              <div class="ptb-18">
                <div *ngFor="let codRecord of top5CodRecords" class="pb-2rem">
                  <div class="searchResultElement width-95 ptb-10"
                       *ngIf="codRecord.source.levelTwo != null && codRecord.source.levelThree != null">
                    <div class="georgiaFont font-14" (click)="redirectToUrl(codRecord.source)">
                      <span *ngIf="codRecord.source.levelTwo !=''">{{codRecord.source.levelTwo}}<img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"> </span>
                      <span *ngIf="codRecord.source.levelThree !=''">{{codRecord.source.levelThree}}<img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right" *ngIf="codRecord.source.levelFour !='' && codRecord.source.levelFour !=null"></span>
                      <span *ngIf="codRecord.source.levelFour !=''">&nbsp;{{codRecord.source.levelFour}} <img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right" *ngIf="codRecord.source.levelFive !='' && codRecord.source.levelFive !=null"></span>
                      <span *ngIf="codRecord.source.levelFive !=''">&nbsp;{{codRecord.source.levelFive}}</span>
                    </div>
                  </div>
                </div>
                <div class="pb-24px" *ngFor="let glossary of CodGlossaryResult">
                  <div class="itcBookFont font-16 ptb-10 flex-display">
                    <span>
                      <img src="../../../assets/icons/OpenBook-white.svg" class="close-icon-image mr-5"
                           alt="Glossary Icon">
                    </span>&nbsp;<span class="font-16 navName">{{glossary.source.title}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="SearchTab == originalPronouncements" class="pt-1-25 pr-3 pr-1rem">
              <div class="searchtable height-80px">{{originalPronouncements}}</div>
              <div class="ptb-18">
                <div *ngFor="let opRecord of top5OpRecords" class="pb-2rem">
                  <div class="searchResultElement width-95 ptb-10"
                       *ngIf="opRecord.source.levelTwo != null && opRecord.source.levelThree != null">
                    <div class="georgiaFont font-14" (click)="redirectToUrl(opRecord.source)">
                      <span *ngIf="opRecord.source.levelTwo !=''">{{opRecord.source.levelTwo}}<img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"> </span>
                      <span *ngIf="opRecord.source.levelThree !=''">{{opRecord.source.levelThree}}<img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right" *ngIf="opRecord.source.levelFour !='' && opRecord.source.levelFour !=null"></span>
                      <span *ngIf="opRecord.source.levelFour !=''">&nbsp;{{opRecord.source.levelFour}} <img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right" *ngIf="opRecord.source.levelFive !='' && opRecord.source.levelFive !=null"></span>
                      <span *ngIf="opRecord.source.levelFive !=''">&nbsp;{{opRecord.source.levelFive}}</span>
                    </div>
                  </div>
                </div>
                <div class="pb-24px" *ngFor="let glossary of OpGlossaryResult">
                  <div class="itcBookFont font-16 ptb-10 flex-display">
                    <span>
                      <img src="../../../assets/icons/OpenBook-white.svg" class="close-icon-image mr-5"
                           alt="Glossary Icon">
                    </span>&nbsp;<span class="font-16 navName">{{glossary.source.title}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="SearchTab == implementationGuide" class="pt-1-25 pr-3 pr-1rem">
              <div class="searchtable height-80px">{{implementationGuide}}</div>
              <div class="ptb-18">
                <div *ngFor="let cigRecord of top5CigRecords" class="pb-2rem">
                  <div class="searchResultElement width-95 ptb-10"
                       *ngIf="(cigRecord.source.levelTwo != null || cigRecord.source.levelTwo != '') && cigRecord.source.levelThree != null">
                    <div class="georgiaFont font-14" (click)="redirectToUrl(cigRecord.source)">
                      <span *ngIf="cigRecord.source.levelTwo !=''">{{cigRecord.source.levelTwo}}<img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"> </span>
                      <span *ngIf="cigRecord.source.levelThree !=''">{{cigRecord.source.levelThree}}<img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right" *ngIf="cigRecord.source.levelFour !='' && cigRecord.source.levelFour !=null"></span>
                      <span *ngIf="cigRecord.source.levelFour !=''">&nbsp;{{cigRecord.source.levelFour}} <img src="../../../assets/icons/Arrow-right-white.svg" class="search-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right" *ngIf="cigRecord.source.levelFive !='' && cigRecord.source.levelFive !=null"></span>
                      <span *ngIf="cigRecord.source.levelFive !=''">&nbsp;{{cigRecord.source.levelFive}}</span>
                    </div>
                  </div>
                </div>
                <div class="pb-24px" *ngFor="let glossary of CigGlossaryResult">
                  <div class="itcBookFont font-16 ptb-10 flex-display">
                    <span>
                      <img src="../../../assets/icons/OpenBook-white.svg" class="close-icon-image mr-5"
                           alt="Glossary Icon">
                    </span>&nbsp;<span class="font-16 navName">{{glossary.source.title}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-1-25 pr-3 width-25 pr-1rem" *ngIf="role!= 'Basic'">
            <div class="searchtable height-80px">{{othersHeader}}</div>
            <div class="ptb-18">

              <div class="pb-24px" *ngFor="let annotation of annotationResult">
                <div class="itcBookFont font-16 ptb-10 flex-display">
                  <div><img src="../../../assets/icons/pencil-white.svg" class="close-icon-image mr-5" alt="Annotation"></div>
                  &nbsp;<div class="font-16 navName">
                    {{annotation.annotationTitle}}<br /><span class="font-14 navName">{{annotation.createdOn.split(" ")[0]}}</span>
                  </div>
                </div>
              </div>
              <div class="pb-24px " *ngFor="let bookmark of bookmarkResult">
                <div class="itcBookFont font-16 ptb-10 flex-display">
                  <span>
                    <img src="../../../assets/icons/bookmark-home-white.svg" class="close-icon-image mr-5"
                         alt="Bookmark">
                  </span>&nbsp;<span class="font-16 navName">{{bookmark.bookmarkTitle}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!flag" #navLevel2 class="menu-overlay-level-2" [class.z-index-negative]="menuIndexNegativeArr[0]" [@slideInOut]="l2State" (@slideInOut.done)="animationDone(l2State,0)" (@slideInOut.start)="animationStart(l2State,0)">
  <div class="fullComponent">
    <div class="nav-level-overflow nav-level-2" *ngIf="(selectedIndexLevel1 || selectedIndexLevel1 === 0) && tempData[selectedIndexLevel1]?.itemData != null">
      <div class="space-div"></div>
      <div class="mb-5-5">
        <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData, index as i" tabindex="0" class="subNavElement " [class.selectedNavElement]="i === selectedIndexLevel2" (click)="selectedIndexLevel2 = i; navClicked(obj,2)" (keyup.enter)="selectedIndexLevel2 = i; navClicked(obj,2)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(2)" (keyup.arrowRight)="nextLevel(2)">
          <div role="navigation" aria-label="{{obj.item}} navigation" class="navName m-Auto" [innerHTML]="obj.item">
          </div>
          <div *ngIf="obj.itemData.length > 0 && obj.rollUp != 'True'" class="m-Auto">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div #navLevel3 class="menu-overlay-level-3" [class.z-index-negative]="menuIndexNegativeArr[1]" [@slideInOut]="l3State" (@slideInOut.done)="animationDone(l3State,1)" (@slideInOut.start)="animationStart(l3State,1)">
  <div class="fullComponent">
    <div class="nav-level-overflow nav-level-3" *ngIf="selectedIndexLevel2 || selectedIndexLevel2 === 0 && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData != null">
      <div class="space-div"></div>
      <div class="mb-5-5">
        <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData, index as i" tabindex="0" class="subNavElement" [class.selectedNavElement]="i === selectedIndexLevel3" (click)="selectedIndexLevel3 = i; navClicked(obj,3)" (keyup.enter)="selectedIndexLevel3 = i; navClicked(obj,3)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(3)" (keyup.arrowRight)="nextLevel(3)">
          <div role="navigation" aria-label="{{obj.item}} navigation" class="navName m-Auto" [innerHTML]="obj.item">
          </div>
          <div *ngIf="obj.itemData.length > 0 && obj.rollUp != 'True'" class="m-Auto">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
         <div class="subNavElement" *ngIf="showallinonepagerequiredon3rdlevel" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2])" >
            <div class="m-Auto">
                <mat-icon>filter_none</mat-icon>
            </div>&nbsp; &nbsp;
            <div class="navName m-Auto">
                Show all in one page
            </div>
        </div> 
      </div>
    </div>
  </div>
</div>

<div #navLevel4 class="menu-overlay-level-4" [class.z-index-negative]="menuIndexNegativeArr[2]" [@slideInOut]="l4State" (@slideInOut.done)="animationDone(l4State,2)" (@slideInOut.start)="animationStart(l4State,2)">
  <div class="fullComponent">
    <div class="nav-level-overflow nav-level-4" *ngIf="selectedIndexLevel3 || selectedIndexLevel3 === 0 && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData != null">
      <div class="space-div"></div>
      <div class="mb-5-5">
        <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData, index as i" tabindex="0" class="subNavElement" [class.selectedForthNavElement]="i === selectedIndexLevel4" (click)="selectedIndexLevel4 = i;navClicked(obj,4)" (keyup.enter)="selectedIndexLevel4 = i;navClicked(obj,4)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(4)">
          <div role="navigation" aria-label="{{obj.item}} navigation" class="navName m-Auto" [innerHTML]="obj.item">
          </div>
          <div *ngIf="obj.itemData.length > 0 && obj.rollUp != 'True'" class="m-Auto">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
        <div class="subNavElement" *ngIf="showallinonepagerequiredon4thlevel" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3])">
          <div class="m-Auto">
            <mat-icon>filter_none</mat-icon>
          </div>&nbsp; &nbsp;
          <div class="navName m-Auto">
            Show all in one page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div #navLevel5 class="menu-overlay-level-5" [class.z-index-negative]="menuIndexNegativeArr[3]" [@slideInOut]="l5State" (@slideInOut.done)="animationDone(l5State,3)" (@slideInOut.start)="animationStart(l5State,3)">
  <div class="fullComponent">
    <div class="nav-level-overflow nav-level-5" *ngIf="selectedIndexLevel4 || selectedIndexLevel4 === 0 && tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[selectedIndexLevel4].itemData != null">
      <div class="space-div"></div>
      <div class="mb-5-5">
        <div *ngFor="let obj of tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[selectedIndexLevel4].itemData, index as i" tabindex="0" class="subNavElement" [class.selectedNavElement]="i === selectedIndexLevel5" (click)="selectedIndexLevel5 = i;navClicked(obj,5)" (keyup.enter)="selectedIndexLevel5 = i;navClicked(obj,5)" (keyup.arrowDown)="nextTab($event)" (keyup.arrowUp)="previousTab($event)" (keyup.arrowLeft)="previousLevel(5)">
          <div role="navigation" aria-label="{{obj.item}} navigation" class="navName m-Auto" [innerHTML]="obj.item">
          </div>
        </div>
        <div class="subNavElement" (click)="showAllInOnePage(tempData[selectedIndexLevel1].itemData[selectedIndexLevel2].itemData[selectedIndexLevel3].itemData[selectedIndexLevel4])">
          <div class="m-Auto">
            <mat-icon>filter_none</mat-icon>
          </div>&nbsp; &nbsp;
          <div class="navName m-Auto">
            Show all in one page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="bread-crumb-overlay" [class.z-index-negative]="menuIndexNegativeArr[0]" [@slideInOut]="l2State" (@slideInOut.done)="animationDone(l2State,0)" (@slideInOut.start)="animationStart(l2State,0)" role="navigation" aria-label="Left Nav Footer">
  <div *ngIf="crumbData.length > 0" class="nav-footer-bread-crumb-container">
    <div *ngFor="let obj of crumbDataNav, index as i" class="nav-bread-crumb">
      <div role="navigation" aria-label="{{obj}} navigation" class="bread-crumb-text">
        {{obj}}
      </div>
      <div>
        <img src="../../../assets/icons/Arrow-Right-light.svg" class="nav-bread-crumb-icon" alt="Arrow Right">
      </div>
    </div>
  </div>
</div>


<div [@slideInOut]="btnState" role="banner" [tabindex]="btnState === 'in' ? 0 : -1" data-message="close navigation" [class.z-index-negative]="menuIndexNegativeArr[0]" class="close-nav-layout" (click)="closeNav()" (keyup.enter)="closeNav()" (keydown.Tab)="closeNav()">
  <button id="close-nav-button" tabindex="-1" mat-raised-button class="close-nav-btn">
    Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Left Navigation">
  </button>
</div>

